import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { OnVisible, SafeKeyLogo } from '@americanexpress/gravity-core';

const GravityHeader = ({
  amount, cardEndingDigits, currencyCode, locale,
}) => {
  const [formattedCurrency, setFormattedCurrency] = useState(null);

  useEffect(() => {
    if (typeof amount === 'number') {
      const formatAry = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currencyCode,
      }).formatToParts(amount);
      let updateFormatted = '';
      formatAry.forEach((obj) => {
        if (obj.type !== 'literal' && obj.type !== 'currency') {
          updateFormatted += obj.value;
        }
      });
      setFormattedCurrency(updateFormatted);
    }
  }, [amount]);

  return (
    <div id="safekeyHeader">
      <OnVisible
        identifier="axp-gravity-header"
      />
      <header className="safekey-header row">
        <div className="col-sm-5 col-xs-5 pad-0-l">
          <img
            className="header-logo"
            src={SafeKeyLogo}
            alt="American Express SafeKey"
          />
        </div>
        <div className="col-sm-7 col-xs-7 flex flex-column pad-1-r">
          <div className="flex flex-justify-end flex-align-center height-full">
            <div
              className="legal-1 safekey-border-margin"
            >
              <div className="text-align-right flex flex-justify-end flex-align-center">
                <span
                  className="icon icon-sm dls-icon-card dls-gray-04 safekey-icon"
                  access="yes"
                  role="img"
                  aria-label="Card image, card ending in:"
                />
                <span className="safekey-sm">{cardEndingDigits}</span>
              </div>
              {formattedCurrency && (
                <div className="text-align-right flex flex-justify-end flex-align-center">
                  <i
                    className="icon icon-sm dls-icon-merchandise dls-gray-04 safekey-icon"
                    role="img"
                    access="yes"
                    aria-label="Shopping bag image, transaction amount:"
                  />
                  <span className="safekey-sm">{`${currencyCode} ${formattedCurrency}`}</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </header>
    </div>
  );
};

GravityHeader.propTypes = {
  amount: PropTypes.number.isRequired,
  cardEndingDigits: PropTypes.string.isRequired,
  currencyCode: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
};

export default GravityHeader;
